import { useTranslation } from 'next-i18next';
import { usePresentationBooking } from '../../../../../../hooks/usePresentationBooking';
import { Slot } from '../../../../../../interfaces/interfaces';
import VyTooltip from '../../../../../common/VyTooltip';

const PresentationTypeWithTooltip = ({ slot, className, textColor }: { slot: Slot; className: string; textColor?: string }) => {
  const { getPresentationType } = usePresentationBooking();
  const { t } = useTranslation();

  const presentationType = getPresentationType(slot);
  const presentationTypeText = presentationType && t(`account:presentation-types.${presentationType}`);
  const presentationTypeTooltip = presentationType && t(`account:presentation-types.${presentationType}-tooltip`);
  return (
    <div className={`${className}`} style={{ color: textColor }}>
      <VyTooltip title={presentationTypeTooltip}>
        <span>{presentationTypeText}</span>
      </VyTooltip>
    </div>
  );
};

export default PresentationTypeWithTooltip;
